import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  CartItem,
  FilterKeyMap,
  FilterKeys,
  Filters,
  Location,
  OneFilter,
} from "../../models/app";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Shower } from "@mui/icons-material";
import { updateUserSystemId } from "../../store/ducks/app";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/ducks";
import ChangeCustomerModal from "../modal/ChangeCustomerModal";

interface CatalogSideBarProps {
  filters: Filters;
  selectedFilters: any;
  setSelectedFilters: React.Dispatch<React.SetStateAction<any>>;
  runFlat: boolean;
  setRunFlat: React.Dispatch<React.SetStateAction<boolean>>;
  inStock: boolean;
  showExternal: boolean;
  setShowExternal: React.Dispatch<React.SetStateAction<boolean>>;
  setInStock: React.Dispatch<React.SetStateAction<boolean>>;
  applyFilters: () => void;
  updateSelectedFilters: any;
  toggleRunFlat: any;
  toggleShowExternal: any;
  toggleInStock: any;
  initialFilters: Filters;
  filterKeyMap: FilterKeyMap;
  availableNow: boolean;
  toggleAvailableNow: any;
  setAvailableNow: React.Dispatch<React.SetStateAction<boolean>>;
}

const CatalogSideBar: React.FC<CatalogSideBarProps> = ({
  filters,
  selectedFilters,
  setSelectedFilters,
  runFlat,
  showExternal,
  setRunFlat,
  setShowExternal,
  inStock,
  setInStock,
  applyFilters,
  updateSelectedFilters,
  toggleRunFlat,
  toggleShowExternal,
  toggleInStock,
  initialFilters,
  filterKeyMap,
  availableNow,
  toggleAvailableNow,
  setAvailableNow
}) => {
  const selectedLocation:Location = useSelector((state: any) => state?.store?.selectedLocation); 
  const cart: CartItem[] = useSelector((state: RootState) => state.store?.cart);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const user = useSelector((state: RootState) => state?.store?.user);
  const [isFiltersVisible, setIsFiltersVisible] = useState(!isMobile);
  const [openChangeCustomer, setOpenChangeCustomer] = useState(false);
  const [subCustomer, setSubCustomer] = useState<string>(() => {
    if (user && user !== "guest" && typeof user.id === "string") {
      const storedId = localStorage.getItem("customeruserSystemId");
      //"630273ea-e3f3-ee11-904c-000d3a8fb2b0"
      return storedId ? storedId : user.id;
    }
    return "";
  });

  const [selectedCustomer, setselectedCustomer] = useState<string>(() => {
    return "";
  });

  useEffect(() => {
    setIsFiltersVisible(!isMobile);
  }, [isMobile]);

  const toggleFiltersVisibility = () => {
    setIsFiltersVisible(!isFiltersVisible);
  };

  const handleFilterChange = (
    filterName: string,
    newValues: (OneFilter | null)[],
  ) => {
    setSelectedFilters((prev: any) => ({ ...prev, [filterName]: newValues }));
    updateSelectedFilters(filterName, newValues);
    applyFilters();
  };

  function isFilterKey(key: any): key is FilterKeys {
    const validKeys: FilterKeys[] = [
      "loadindex",
      "speedrating",
      "ratio",
      "wheelSize",
      "width",
      "sidewalls",
      "brand",
      "model",
      "season",
      "oeCode",
    ];
    return validKeys.includes(key);
  }
  const reloadpage = (selectedCustomer: string) => {
    var filteredSubCustomers = filters.subCustomers.filter(
      (w) => w.code === selectedCustomer,
    );
    var canCheckOut =
      filteredSubCustomers.length > 0
        ? !filteredSubCustomers[0].privacyblocked
        : false;
    localStorage.setItem("CanCheckOut", String(canCheckOut));
    localStorage.setItem("customeruserSystemId", selectedCustomer);
    window.location.reload();
  };

  return (
    <div
      style={{
        border: "2px solid #e5e5e5",
        borderRadius: "5px",
        padding: "10px",
        height: "fit-content",
      }}
    >
      <Accordion
        disableGutters
        elevation={0}
        square
        expanded={isFiltersVisible}
        onChange={toggleFiltersVisibility}
        sx={{
          width: "100%",
          borderRadius: "5px",
          "&::before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ "& .MuiAccordionSummary-content": { margin: "0px" } }}
        >
          <Typography variant="h6" sx={{ fontSize: "18px" }}>
            Filters
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{ padding: "10px", paddingBottom: "0px", marginBottom: "0px" }}
        >
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={runFlat}
                  onChange={() => {
                    setRunFlat(!runFlat);
                    toggleRunFlat();
                    applyFilters();
                  }}
                />
              }
              label="Run Flat"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={showExternal}
                  onChange={() => {
                    setShowExternal(!showExternal);
                    toggleShowExternal();
                    applyFilters();
                  }}
                />
              }
              label="Include Special Order "
              style={{ color: "blue" }}
            />
          </FormGroup>
 { <FormGroup>
            <FormControlLabel
              control={
                <Switch

             
                  checked={availableNow}
                  onChange={() => {
                     setAvailableNow(!availableNow);
                    toggleAvailableNow();
                    applyFilters();
                  }}
                />
              }
           label={`Available now (${selectedLocation?.displayName})`}

            />
          </FormGroup> }
          {filters.subCustomers.length > 0 && (
            <FormControl fullWidth style={{ marginTop: 16 }}>
              {/* <Autocomplete
             options={filters.subCustomers}
             getOptionLabel={(option) => option.description} 
             value={filters.subCustomers.find((sub) => sub.code === subCustomer) || null} 
             disableClearable={true}
             onChange={(event, newValue) => {
              setselectedCustomer(newValue ? newValue.code : "")
              if(cart.length > 0){
                setOpenChangeCustomer(true);
              
              }
              else{
                setSubCustomer(newValue ? newValue.code : ""); 
                reloadpage(newValue ? newValue.code : "");
              }
              
             }}
             renderInput={(params) => (
               <TextField {...params} label="Profile" variant="outlined" />
             )}
           /> */}
              <Typography variant="h6" style={{ fontSize: "16px" }}>
                Profile
              </Typography>
              <Select
                value={
                  filters.subCustomers.find((sub) => sub.code === subCustomer)
                    ?.code || ""
                }
                onChange={(event) => {
                  const newValue = filters.subCustomers.find(
                    (sub) => sub.code === event.target.value,
                  );
                  setselectedCustomer(newValue ? newValue.code : "");

                  if (cart.length > 0) {
                    setOpenChangeCustomer(true);
                  } else {
                    setSubCustomer(newValue ? newValue.code : "");
                    reloadpage(newValue ? newValue.code : "");
                  }
                }}
                displayEmpty
              >
                {filters.subCustomers.map((sub) => (
                  <MenuItem key={sub.code} value={sub.code}>
                    {sub.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {Object.entries(initialFilters)
            .filter(
              ([filterName]) =>
                filterName !== "width" &&
                filterName !== "wheelSize" &&
                filterName !== "ratio" &&
                isFilterKey(filterName),
            )
            .map(([filterName, initialFilterOptions]) => (
              <div
                key={filterName}
                style={{ marginBottom: "10px", marginTop: "0px" }}
              >
                <Typography variant="h6" style={{ fontSize: "16px" }}>
                  {filterKeyMap[filterName] ?? filterName}
                </Typography>
                <FormControl fullWidth margin="none">
                  <Autocomplete
                    multiple
                    value={selectedFilters[filterName] || []}
                    onChange={(_, newValues) =>
                      handleFilterChange(filterName, newValues)
                    }
                    options={initialFilterOptions.filter((option) => {
                      const currentOption = filters[filterName].find(
                        (o) => o.code === option.code,
                      );
                      return currentOption && currentOption.count > 0;
                    })}
                    getOptionLabel={(option: OneFilter) => {
                      const currentOption = filters[filterName].find(
                        (o) => o.code === option.code,
                      );
                      const count = currentOption ? currentOption.count : 0;
                      return `${option.description} (${count})`;
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label={filterName} />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.code === value.code
                    }
                  />
                </FormControl>
              </div>
            ))}

          {/* <FormGroup>
            <FormControlLabel
              control={<Switch checked={!inStock} onChange={() => { setInStock(!inStock); toggleInStock(); }} />}
              label="Include Out of Stock Items"
            />
          </FormGroup> */}
         
        </AccordionDetails>
        <ChangeCustomerModal
          open={openChangeCustomer}
          setOpen={setOpenChangeCustomer}
          field={selectedCustomer}
          subCustomers={filters.subCustomers}
          setOpenChangeCustomer={setOpenChangeCustomer}
        ></ChangeCustomerModal>
      </Accordion>
    </div>
  );
};

export default CatalogSideBar;
